module.exports = __webpack_public_path__ + "nr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nr.svg
// module id = 995
// module chunks = 0